import { createContext, ReactNode, useState } from 'react';
import { isUserTheTeacher } from '../utils/userUtils';
import { isLoggedInOrRemembered } from '../utils/isLoggedIn';

type UserType = 'TEACHER' | 'DONOR';
type ViewModes = UserType;
export const ViewMode = {
    TEACHER: 'TEACHER' as ViewModes,
    DONOR: 'DONOR' as ViewModes,
};

export const TeacherPageContext = createContext({
    isOwner: false,
    viewMode: ViewMode.DONOR,
    setViewMode: (viewMode: UserType) => {},
    showDonorFeatures: true,
    toggleViewMode: () => {
    },
});

interface TeacherPageContextProviderProps {
    children: ReactNode,
}

// TODO interact with this i guess
export const TeacherPageContextProvider = ({
    children,
}: TeacherPageContextProviderProps) => {
    const isOwner = isUserTheTeacher() && isLoggedInOrRemembered();
    const [viewMode, setViewMode] = useState(isOwner ? ViewMode.TEACHER : ViewMode.DONOR);

    const showDonorFeatures = viewMode === ViewMode.DONOR;
    const toggleViewMode = () => {
        if (isOwner) {
            setViewMode(prev => (prev === ViewMode.TEACHER ? ViewMode.DONOR : ViewMode.TEACHER));
        }
    };

    return <TeacherPageContext.Provider value={{
        isOwner,
        viewMode,
        setViewMode,
        showDonorFeatures,
        toggleViewMode,
    }}>
        {children}
    </TeacherPageContext.Provider>;
};
